<template>
  <div class="main-banner">
    <div class="container">
      <div class="banner-content">
        <p class="banner-brand">patrimonea by Gwem</p>
        <h1 class="banner-title">
          Vous êtes criblé de dettes&nbsp;?
          <span class="banner-title__break">Vous ne savez pas comment investir&nbsp;?</span>
        </h1>
        <p class="banner-lead">
          En 15 minutes, une vision consolidée de votre situation et un plan d’action.
        </p>
        <div class="banner-actions">
          <router-link
            to="/diagnostic"
            class="btn-brand btn-brand--primary btn-lg banner-cta-primary"
            @click="onPrimary"
          >
            Faire mon diagnostic
          </router-link>
          <router-link
            to="/platforme"
            class="btn-brand btn-brand--on-dark btn-lg banner-cta-secondary"
            @click="onSecondary"
          >
            Découvrir la plateforme
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { trackCtaClick } from '@/utils/analytics';

function onPrimary() {
  trackCtaClick({ location: 'home_hero', label: 'Faire mon diagnostic' });
}
function onSecondary() {
  trackCtaClick({ location: 'home_hero', label: 'Découvrir la plateforme' });
}
</script>

<style scoped>
.main-banner {
  background:
    linear-gradient(
      105deg,
      rgba(84, 57, 41, 0.94) 0%,
      rgba(84, 57, 41, 0.78) 48%,
      rgba(1, 38, 62, 0.42) 100%
    ),
    url(@/assets/img/hero-patrimoine-familial.png);
  background-size: cover;
  background-position: center right;
  color: var(--paper, #fff);
  padding: clamp(72px, 8vw, 110px) 0 clamp(64px, 7vw, 100px);
  position: relative;
  overflow: hidden;
  isolation: isolate;
  min-height: min(620px, 92vh);
  display: flex;
  align-items: center;
  font-family: var(--font-body);
}

.banner-content {
  max-width: 36rem;
}

.banner-brand {
  margin: 0 0 0.75rem;
  font-family: var(--font-display);
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--brand-gold, #c9a227);
}

.banner-brand::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  margin-top: 0.55rem;
  border-radius: 2px;
  background: linear-gradient(90deg, var(--brand-brown), var(--brand-gold));
}

.banner-title {
  font-family: var(--font-display);
  font-size: clamp(1.55rem, 3.2vw, 2.35rem);
  font-weight: 600;
  line-height: 1.22;
  margin: 0 0 0.85rem;
  max-width: 22ch;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.35);
}

.banner-title__break {
  display: block;
}

.banner-lead {
  margin: 0 0 1.35rem;
  max-width: 36ch;
  font-family: var(--font-body);
  font-size: clamp(1rem, 0.95rem + 0.3vw, 1.1rem);
  font-weight: 400;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.3);
}

.banner-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.banner-cta-primary,
.banner-cta-secondary {
  text-transform: none;
  letter-spacing: 0.02em;
  font-family: var(--font-body);
  font-size: 0.95rem;
  height: auto;
  min-height: 48px;
  padding: 0.75rem 1.35rem;
  white-space: normal;
  text-align: center;
}

@media (max-width: 767px) {
  .main-banner {
    background-image:
      linear-gradient(180deg, rgba(84, 57, 41, 0.82), rgba(84, 57, 41, 0.94)),
      url(@/assets/img/hero-patrimoine-familial.png);
    background-position: top center;
    min-height: auto;
  }

  .banner-title {
    max-width: none;
  }
}
</style>
